import { ButtonMain } from '@/modules/common/components/button';
import styles from './index.module.sass';
import strucIcon from '@@/mixing/components/recipes-detail/icons/struc.svg';
import tempIcon from '@@/mixing/components/recipes-detail/icons/temp.svg';
import rotateArrowIcon from '@@/mixing/components/recipes-detail/icons/rotate-arrow.svg';
import bgSell from '@@/mixing/components/recipes-detail/icons/bg-1.svg';
import classNames from 'classnames';
import arrowButton from '@@/mixing/components/recipes-detail/icons/arrow-button.svg';
import weightSvg from '@@/mixing/components/recipes-detail/icons/weight.svg';
import arrowWide from '@@/mixing/components/recipes-detail/icons/arrow-wide.svg';
import arrowIcon from '@@/mixing/components/recipes-detail/icons/arrow.svg';
import { useEffect, useState } from 'react';
import { Modal, Tooltip } from 'antd';
import iconInfo from '@@/mixing/images/info-icon.svg';
import { ILeftoverTooltipData } from '@/modules/common/components/mix-item/components/leftover-tooltip';
import { AgricultureMetrics } from '@/modules/mixing/store/analytical-mixing.store';
import { Humidity } from '@/shared/ui/icons';
import { humidityLvlColor } from '@/modules/common/utils/get-humidity-color';
import { ILeftoverBag } from '@/widgets/recipe/types';
import { SellContentModal } from '@/modules/common/components/sell-content-modal';
import { useStore } from 'effector-react';
import { $selectedRecipeStore } from '@/modules/mixing/store/recipes.store';
import {
  $topRecipesForWarehouse,
  fetchTopRecipesForWarehouse,
} from '@/widgets/recipe/model';
import { DetalisationTooltip } from '@/modules/common/components/detalisation-tooltip';
import { useNavigate } from 'react-router-dom';
import { createOfferFoo } from '@/modules/common/utils/create-offer.function';
import { indicateWheatType } from '@/modules/common/helpers/wheat-type.helper';
import { RecipesService } from '@/modules/common/services/recipes.service';
import { RubleRegular } from '@/modules/common/components/ruble-regular';
import ResponsiveSvgComponent from '@/shared/ui/responsive-wheat-heap';
import { useWindowDimensions } from '@/modules/common/hooks/use-window-dimensions.hook';

export const LeftoverItem = ({
  data,
  id,
  weight,
  culture,
  type,
  sort,
  classN,
  offer,
  action,
  targetHumidity,
  leftoverTooltip,
  params,
  weightGain,
  saveScrollPosition,
}: IArgs) => {
  const TARGET_HUMIDITY = data.offer_humidity;
  const [modalOpen, setModalOpen] = useState(false);
  const [modalViewOnly, setModalViewOnly] = useState(false);
  const [actionState, setActionState] = useState<'drain' | 'hydrate' | null>(
    TARGET_HUMIDITY === +params.humidity
      ? null
      : TARGET_HUMIDITY > +params.humidity
      ? 'hydrate'
      : 'drain',
  );
  const offerHumidity = data.offer_humidity;
  const bagHumidity = +data.values.humidity;
  const weight_gain_tons = !data.trade_id
    ? data.weight_gain_tons
    : +data.initial_weight_gain_tons;

  const activeWh = useStore($selectedRecipeStore);
  const isStationary = activeWh?.type === '1';
  const topRecipesData = useStore($topRecipesForWarehouse);
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  useEffect(() => {
    if (params) {
      setActionState(
        TARGET_HUMIDITY === +params.humidity
          ? null
          : TARGET_HUMIDITY > +params.humidity
          ? 'hydrate'
          : 'drain',
      );
    }
  }, [params]);

  const sleeveData = {
    ...data,
    class: String(data.class),
    agriculture: 'Пшеница',
    agriculture_id: 1,
    buyers: [],
    destination_id: data.destination_id,
    freight_cost_after_moisture_mod: data.freight_cost_after_moisture_mod,
    freight_cost_before_moisture_mod: data.freight_cost_before_moisture_mod,
    freight_cost_tkm: data.freight_cost_tkm,
    id: data.bag,
    is_wheat: false,
    mixes: [],
    price_id: data.price_id,
    status: data.status,
  };

  const offerForTrade = {
    buyer: data.buyer_company,
    buyer_id: 0,
    class: `${String(data.class)} класс`,
    company_id: 0,
    distance: data.distance,
    freight_price_per_ton: data.initial_price_logistic / data.weight,
    freight_price: data.initial_price_logistic,
    netto: data.initial_price_netto,
    price_all: data.initial_price,
    price_per_ton: data.price_per_ton,
    type: data.type,
  };

  const recipesService = new RecipesService(offerForTrade, sleeveData);
  const hydartedCasePrices = recipesService.calculateHydrateParams();
  const drainCasePrices = recipesService.calculateDrainParams();

  id === '02510008' && console.log(drainCasePrices);

  const sellRemainsClick = async () => {
    saveScrollPosition();

    if (TARGET_HUMIDITY === +params.humidity) {
      const offerFoo = await createOfferFoo({
        action: null,
        price: offer?.priceTon || 0,
        weight: sleeveData?.weight,
        weight_gain_tons: data.weight_gain_tons,
        initial_weight_gain_tons: weight_gain_tons,
        sleeveData,
        onCancel: async () =>
          activeWh?.id && fetchTopRecipesForWarehouse(Number(activeWh?.id)),
        offer: offerForTrade,
        warehouseId: Number(activeWh?.id),
        additionalData: {
          initial_price_logistic: sleeveData.price_logistic,
          action_place: null,
          mix_id: null,
          mixing_profit: null,
          price_logistic: sleeveData.freight_cost_after_moisture_mod,
          price_netto: sleeveData.price_netto,
          price_all: sleeveData.all_price,
          is_remnants: true,
        },
        signature: topRecipesData?.mix_signature,
        //wheat_type_n: Number(indicateWheatType(sleeveData.sort, sleeveData.type)),
      });
      return offerFoo;
    } else {
      setModalOpen(true);
      return;
    }
  };
  return (
    <div
      className={classNames(styles.root, action?.type === undefined && styles.noCase, isStationary && styles.heap)}
    >
      <div className={styles.mainInfo}>
        <div className={styles.row}>
          <span className={styles.label}>
            {isStationary ? 'id объема' : 'id рукава'}
          </span>
          <span className={styles.value}>
            {id}
            {/* <LeftoversTooltip components={leftoverTooltip.components} /> */}
          </span>
        </div>
        <div className={styles.row}>
          <span className={styles.label}>вес пшеницы</span>
          <span className={styles.value}>
            {' '}
            {weight % 1 !== 0 ? weight.toFixed() : weight} т
          </span>
        </div>
      </div>
      <div className={isStationary && width > 2230 ? styles.wheatHeapInfo : styles.wheatInfo}>
      {isStationary && width > 2230 && <ResponsiveSvgComponent/>}
        <div className={isStationary && width > 2230 && styles.infoText}>
          <span className={styles.classInfo}>
            {culture}, {+classN === 0 ? 'Фураж ' : `${classN}-й класс `}
          </span>
          <span className={styles.typeInfo}>
            {sort} {type}
          </span>
          <div className={styles.params}>
            <span className={styles.param}>
              <Humidity fill={humidityLvlColor(Number(params.humidity))} />{' '}
              {params.humidity}%
            </span>
            <span className={styles.param}>
              <img src={strucIcon} className={styles.icon} /> {params.gluten}%
            </span>
            <span className={styles.param}>
              <img src={tempIcon} className={styles.icon} /> {params.temperature}°C
            </span>
          </div>
        </div>
      </div>
      {action && (
        <div className={styles.targetHumidity}>
          {!targetHumidity || TARGET_HUMIDITY === +params.humidity ? (
            <span>
              действий с влажностью <br />
              не требуется
            </span>
          ) : (
            <div className={styles.additional}>
              <span className={styles.callToAction}>
                {TARGET_HUMIDITY < +params.humidity
                  ? 'требуется осушение'
                  : 'можно увлажнить'}{' '}
                <img src={arrowButton} />
              </span>
              <div className={styles.params}>
                <div className={styles.paramLine}>
                  <span className={styles.paramItem}>
                    <Humidity fill={humidityLvlColor(Number(params.humidity))} />{' '}
                    {params.humidity}%
                  </span>
                  <img className={styles.arrow} src={arrowIcon} />
                  <span className={styles.paramItem}>
                    <Humidity fill={humidityLvlColor(TARGET_HUMIDITY)} />{' '}
                    {TARGET_HUMIDITY}%
                  </span>
                </div>
                <div className={styles.paramLine}>
                  <span className={styles.paramItem}>
                    <img src={weightSvg} alt="drop icon" /> {weight} т
                  </span>
                  <img className={styles.arrow} src={arrowIcon} />
                  <span className={styles.paramItem}>
                    <img src={weightSvg} alt="" />{' '}
                    {(weight + weight_gain_tons).toLocaleString('ru', {
                      maximumFractionDigits: 2,
                    })}{' '}
                    т
                  </span>
                </div>
                <div className={styles.paramLine}>
                  <span className={styles.paramItem}>н {data.values.nature}</span>
                  <img className={styles.arrow} src={arrowIcon} />
                  <span className={styles.paramItem}>н {data.new_nature}</span>
                </div>
              </div>
            </div>
          )}
          <img className={styles.arrowWide} src={arrowWide} alt="arrow wide" />
        </div>
      )}
      {(action?.type === 'sell' || action?.type === 'busy') && offer ? (
        <>
          <div className={styles.buyerInfo}>
            <div className={styles.topInfo}>
              <span className={styles.buyerLabel}>
                <Tooltip title={offer?.buyer}>{offer?.buyer}</Tooltip>
              </span>
              <span className={styles.action} style={{ marginLeft: '4px' }}>
                заменить покупателя{' '}
                <img src={rotateArrowIcon} className={styles.icon} />
              </span>
            </div>
            <div className={styles.bottomArea}>
              <div className={styles.col}>
                <span className={styles.label}>цена</span>
                <span className={styles.value}>
                  {toLocale(offer?.priceTon) || '0'}{' '}
                  <RubleRegular customSymbol="₽/т" p={0} />
                </span>
              </div>
              <div className={styles.col}>
                <span className={styles.label}>
                  логистика{' '}
                  {!offer?.priceLogistic && !offer?.distance ? (
                    <DetalisationTooltip
                      status={data.status as any}
                      rangeKm={offer?.distance}
                      navigate={navigate}
                    />
                  ) : !offer.priceLogistic && offer.distance ? (
                    <DetalisationTooltip
                      status={data.status as any}
                      rangeKm={offer?.distance}
                      red={true}
                      navigate={navigate}
                    />
                  ) : (
                    ''
                  )}
                </span>
                <span className={styles.value}>
                  {!offer.priceLogistic && !offer.distance ? (
                    <span className={styles.selfDelivery}>
                      {data.status === 'BuyerPickupEnforced'
                        ? 'самовывоз'
                        : 'по договоренности'}
                    </span>
                  ) : (
                    <>
                      {toLocale(
                        Math.max(
                          offer?.priceLogistic,
                          offer?.freight_cost_after_moisture_mod,
                          offer?.freight_cost_before_moisture_mod,
                        )
                      , { maximumFractionDigits: 0 }) || '0'}{' '}
                      <RubleRegular p={0} />{' '}
                      <span className={styles.innerRegular}>
                        {toLocale(offer?.distance) || '0'} км
                      </span>
                    </>
                  )}
                </span>
              </div>
              <div className={styles.col}>
                <span className={styles.label}>влажность</span>
                <span className={classNames(styles.value, styles.humidity)}>
                  <Humidity fill={humidityLvlColor(TARGET_HUMIDITY)} />{' '}
                  {TARGET_HUMIDITY}%
                </span>
              </div>
            </div>
          </div>
          <div className={styles.businessInfo}>
            <div className={styles.row}>
              <span className={styles.label}>
                Стоимость остатка{' '}
                {offer?.priceLogistic && offer.distance ? 'без учета логистики' : ''}
              </span>
              {actionState === 'hydrate' &&
              data.weight !== data.weight + weight_gain_tons ? (
                <span className={styles.value}>
                  {(sleeveData.weight * offer.priceTon).toLocaleString('ru', {
                    maximumFractionDigits: 0,
                  })}{' '}
                  <RubleRegular p={0} customSymbol="₽" />{' '}
                  <span className={styles.innerRegular}>
                    (
                    {data.weight.toLocaleString('ru', {
                      maximumFractionDigits: 2,
                    })}
                    т)
                  </span>{' '}
                  -{' '}
                  {(
                    (data.weight + weight_gain_tons) *
                    Number(offer?.priceTon)
                  ).toLocaleString('ru', { maximumFractionDigits: 0 })}{' '}
                  <RubleRegular p={0} customSymbol="₽" />{' '}
                  <span className={styles.innerRegular}>
                    (
                    {(data.weight + weight_gain_tons).toLocaleString('ru', {
                      maximumFractionDigits: 2,
                    })}
                    т)
                  </span>
                </span>
              ) : (
                <span className={styles.value}>
                  {(
                    (+data.weight + +weight_gain_tons) *
                    Number(offer?.priceTon)
                  ).toLocaleString('ru', { maximumFractionDigits: 0 })}{' '}
                  <span className={styles.innerRegular}>
                    ₽ (
                    {(data.weight + weight_gain_tons).toLocaleString('ru', {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 0,
                    })}{' '}
                    т)
                  </span>
                </span>
              )}
            </div>
            <div className={styles.row}>
              <span className={styles.label}>
                {offer?.priceLogistic && offer.distance
                  ? 'Стоимость остатка с уч. логистики'
                  : 'Конечная стоимость остатка'}{' '}
              </span>
              <span
                className={styles.value}
                onClick={
                  data.freight_cost_after_moisture_mod ===
                  data.freight_cost_before_moisture_mod
                    ? offerHumidity > bagHumidity
                      ? () => {
                          setModalViewOnly(true);
                          setModalOpen(true);
                        }
                      : undefined
                    : () => {
                        setModalViewOnly(true);
                        setModalOpen(true);
                      }
                }
                style={{ cursor: 'pointer' }}
              >
                {actionState === 'drain' ? (
                  drainCasePrices.drainAfter.netto !==
                  drainCasePrices.drainBefore.netto ? (
                    <>
                      {drainCasePrices.drainAfter.netto.toLocaleString('ru', {
                        maximumFractionDigits: 0,
                      })}{' '}
                      <RubleRegular customSymbol="₽" /> - {' '}
                      {drainCasePrices.drainBefore.netto.toLocaleString('ru', {
                        maximumFractionDigits: 0,
                      })}{' '}
                      <RubleRegular customSymbol="₽" />
                    </>
                  ) : (
                    <>
                      {drainCasePrices.drainBefore.netto.toLocaleString('ru', {
                        maximumFractionDigits: 0,
                      })}
                      <RubleRegular customSymbol="₽" />
                    </>
                  )
                ) : actionState === 'hydrate' ? (
                  data.weight * offer.priceTon -
                    data.freight_cost_before_moisture_mod ===
                  hydartedCasePrices.hydrateAfter.netto ? (
                    <>
                      {(
                        data.weight * offer.priceTon -
                        data.freight_cost_before_moisture_mod
                      ).toLocaleString('ru', {
                        maximumFractionDigits: 0,
                      })}{' '}
                      <RubleRegular customSymbol="₽" /> - {' '}
                      {hydartedCasePrices.hydrateAfter.netto.toLocaleString('ru', {
                        maximumFractionDigits: 0,
                      })}
                    </>
                  ) : (
                    <>
                      {hydartedCasePrices.original.netto.toLocaleString('ru', {
                        maximumFractionDigits: 0,
                      })}
                      <RubleRegular customSymbol="₽" /> -{' '}
                      {hydartedCasePrices.hydrateAfter.netto.toLocaleString('ru', {
                        maximumFractionDigits: 0,
                      })}
                      <RubleRegular customSymbol="₽" />
                    </>
                  )
                ) : (
                  <>
                    {(
                      (weight + weightGain) * offer.priceTon -
                      offer.priceLogistic
                    ).toLocaleString('ru', {
                      maximumFractionDigits: 0,
                    })}{' '}
                    <RubleRegular customSymbol="₽" />
                  </>
                )}
                {/* {weight * offer.priceTon !== (weight + weightGain) * offer.priceTon
                  ? `${Math.min(
                      (weight + weightGain) * offer.priceTon - offer.priceLogistic,
                      weight * offer.priceTon - offer.priceLogistic,
                    ).toLocaleString('ru', { maximumFractionDigits: 0 })} - ${Math.max(
                      (weight + weightGain) * offer.priceTon - offer.priceLogistic,
                      (weight + weightGain) * offer.priceTon - Math.min(offer.priceLogistic, offer.freight_cost_after_moisture_mod, offer.freight_cost_before_moisture_mod),
                    ).toLocaleString('ru', { maximumFractionDigits: 0 })}`
                  : offer.sleevePriceNetto.toLocaleString('ru')} */}{' '}
                {data.freight_cost_after_moisture_mod ===
                data.freight_cost_before_moisture_mod ? (
                  offerHumidity > bagHumidity ? (
                    <img alt="info" src={iconInfo} />
                  ) : (
                    ''
                  )
                ) : (
                  <img alt="info" src={iconInfo} />
                )}
              </span>
            </div>
          </div>
        </>
      ) : (
        <div className={styles.note}>
          <span className={styles.label}>
            {isStationary
              ? 'Нет предложений от покупателей о покупке данного объема'
              : 'Нет предложений от покупателей о покупке рукава'}
          </span>
          <span className={styles.value}>
            К сожалению это зерно не используется в рецептах для миксования
          </span>
        </div>
      )}
      <div className={styles.actionArea}>
        {action?.onClick && action?.type === 'sell' ? (
          <ButtonMain
            onClick={sellRemainsClick}
            className={styles.sellAction}
            label={'продать остаток'}
          />
        ) : action?.type === 'busy' ? (
          <div className={styles.busyAction}>
            <span className={styles.busyLabel}>остаток участвует в сделке</span>
            <span
              className={styles.busyButton}
              onClick={() => {
                action.onClick();
              }}
            >
              отменить сделку
            </span>
          </div>
        ) : (
          ''
        )}
      </div>
      <img className={styles.bgImg} src={bgSell} />
      <Modal
        open={modalOpen}
        onCancel={() => {
          setModalOpen(false);
          setModalViewOnly(false);
        }}
        centered
        footer={null}
        rootClassName={styles.confirmModal}
        width={actionState === 'hydrate' ? 1024 : 880}
      >
        {actionState !== null && (
          <SellContentModal
            isLeftover={true}
            onCancel={() => {
              setModalOpen(false);
              setModalViewOnly(false);
            }}
            onSuccess={
              activeWh
                ? async () => fetchTopRecipesForWarehouse(Number(activeWh.id))
                : undefined
            }
            modalViewOnly={modalViewOnly}
            sleeveData={sleeveData}
            offer={offerForTrade}
            action={actionState}
          />
        )}
      </Modal>
    </div>
  );
};

interface IArgs {
  data: ILeftoverBag;
  id: string;
  weight: number;
  weightGain: number;
  culture: string;
  type: string;
  sort: string;
  classN: string;
  isStationary: boolean;
  saveScrollPosition: () => void;
  offer?: {
    buyer: string;
    priceTon: number;
    priceLogistic: number;
    logisticPriceTkm: number;
    priceLogisticInitial: number;
    distance: number;
    sleevePrice: number;
    sleevePriceNetto: number;
    freight_cost_before_moisture_mod: number;
    freight_cost_after_moisture_mod: number;
  };
  action?: {
    type: 'sell' | 'busy';
    onClick: () => void;
  };
  targetHumidity?: {
    weight: number;
    humidity: number;
  };
  leftoverTooltip: ILeftoverTooltipData;
  params: AgricultureMetrics;
}

function toLocale(num?: number, params?: Intl.NumberFormatOptions) {
  return num ? num.toLocaleString('RU-ru', params) : num;
}
